import type { GenericFilterModel } from '@tractian/ui-filters'

import { base64JsonCodec } from '@/lib/url-params/codecs'
import { useUrlParam } from '@/lib/url-params/use-url-param'

/** URL param the toolkit filters are persisted under. Exported so callers that
 * must write it alongside another param can do so in a single navigation. */
export const FILTERS_PARAM_KEY = 'filters'

export function useQueryParamsFilters<T extends GenericFilterModel>() {
  return useUrlParam<T>(FILTERS_PARAM_KEY, base64JsonCodec<T>())
}
